exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/*# sourceMappingURL=src/components/pages/Cdu.css.map */", "", {"version":3,"sources":["D:/Build/MM2/Main/Web/CTS/Odds Boards/src/components/pages/Cdu.vue"],"names":[],"mappings":"AAAA,wDAAwD","file":"Cdu.vue","sourcesContent":["/*# sourceMappingURL=src/components/pages/Cdu.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67cfcee9","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/Cdu.vue
// module id = MdEW
// module chunks = 1